export const INFOPANEL_CTA_LINK =
  'https://api.whatsapp.com/send/?phone=551137779670&text=Ol%C3%A1%21+Quero+saber+mais+sobre+o+plano+Pro+do+ISA+-+InfoPanel&type=phone_number&app_absent=0';

export const INFOPANEL_MONITORAMENTO_CTA_LINK =
  'https://api.whatsapp.com/send/?phone=551137779670&text=Ol%C3%A1%2C+tenho+d%C3%BAvidas+sobre+o+InfoPanel+PRO&type=phone_number&app_absent=0';
